import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent, WmsToggleComponent } from '@wms/components';
import { cloneDeep, isEqual, reject } from 'lodash-es';
import { FormsModule } from '@angular/forms';
import { FilterCriteriaService } from '@wms/services';
import { WmsCriteriaRuleComponent } from '../wms-criteria-rule/wms-criteria-rule.component';
import { generateGUId } from '@wm/core';
import { CommonWidgetDirective } from "@wms/directives";

@Component({
  standalone: true,
  selector: 'wms-criteria-group',
  templateUrl: './wms-criteria-group.component.html',
  styleUrls: ['./wms-criteria-group.component.less'],
  imports: [CommonModule, WmsToggleComponent, WmsCriteriaRuleComponent, FormsModule, CommonWidgetDirective]
})
export class WmsCriteriaGroupComponent extends BaseComponent implements OnInit {
  @Input() depth: any;
  @Input() rules: any;
  @Input() parentGroup?: any;
  @Input() filterFields: any;
  @Input() isDefaultGroup?: any;
  @Input() liveWidgetSettingsService: any;
  id: any;

  constructor(public filterCriteriaService: FilterCriteriaService) {
    super();
  }

  ngOnInit(): void {
    this.id = 'criteria_group' + generateGUId()
  }

  getCurrentDepth() {
    return parseInt(this.depth, 10) + 1;
  }

  showGroupButton() {
    return this.depth < 2;
  }

  addGroup() {
    this.rules.rules.push(cloneDeep(this.filterCriteriaService.CRITERIA_GROUP));
  }

  deleteGroup() {
    this.parentGroup.rules = reject(this.parentGroup.rules, this.rules);
    this.filterCriteriaService.markVariableUpdated();
  }

  onChange(checked: boolean, onValue: string, offValue: string) {
    this.rules.condition = checked ? onValue : offValue
  }
}
